import React from 'react';
import MyAssignedLeads from './MyAssignedLeads';
import './EmployeeLeadsView.css';

function EmployeeLeadsView() {
  return (
    <div className="employee-leads-container">
      {/* My Assigned Leads Section */}
      <div style={{ marginTop: '40px' }}>
        <MyAssignedLeads />
      </div>
    </div>
  );
}

export default EmployeeLeadsView;
